module.exports = __webpack_public_path__ + "img/rangcha_qr.7c077a97.png";